export default __webpack_public_path__ + "static/media/lato-bold.2ee83fd3.woff2";